export const en = {
    'empty-custom-period': 'Specify the number of days',
    'empty-shows-limit': 'Specify the frequency of impressions'
};
